import React from 'react';

const AdminPage = () => {
    return (
        <div>
            <h2 className="text-xl sm:text-2xl font-bold text-white mb-4 sm:mb-6">🛡️ Администрирование</h2>
            <div className="bg-slate-800 rounded-xl p-4 sm:p-6 border border-slate-700">
                <p className="text-slate-400 text-sm sm:text-base">Управление пользователями и правами доступа</p>
            </div>
        </div>
    );
};

export default AdminPage;